import { defined, notDefined } from '@vy/null';
import type { Customer } from '@vy/types';
import { CUSTOMER_SOURCES } from '@vy/types';
import type { ExternalLinkProvider } from '../../../../../../../../hooks/requests/use-get-external-link';
import { getCrmProviderFromIntegrationEntities } from '../../../../../../../../hooks/requests/use-get-external-link';
import { useConnectedCrmProvider } from './use-connected-crm-provider';

export function useCustomerExternalLinkProvider(
  customer: Customer | undefined,
): ExternalLinkProvider | null {
  const connectedProvider = useConnectedCrmProvider();

  if (notDefined(customer)) return null;

  if (customer.source === CUSTOMER_SOURCES.Salesforce) return 'Salesforce';
  if (customer.source === CUSTOMER_SOURCES.HubSpot) return 'Hubspot';

  const entityProvider = getCrmProviderFromIntegrationEntities(customer.integrationEntities);
  if (defined(entityProvider)) return entityProvider;

  if (defined(customer.crmId) && defined(connectedProvider)) return connectedProvider;

  return null;
}
